// src/RTK/productDetailsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

/**
 * Async thunk to fetch product details from the API.
 * @param {string} productId - ID of the product to fetch.
 */
export const fetchProductDetails = createAsyncThunk(
  "productDetails/fetchProductDetails",
  async (productId, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${apiUrl}/Products/${productId}`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      console.log("Product Details Response:", response.data);
      return response.data; // Return the response data directly
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch product details"
      );
    }
  }
);

/**
 * Async thunk to delete a product from the API.
 * @param {string} product_id - ID of the product to delete.
 */
export const deleteProduct = createAsyncThunk(
  "productDetails/deleteProduct",
  async (product_id, { rejectWithValue }) => {
    try {
      await axios.delete(`${apiUrl}/Products/${product_id}/Delete/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      return product_id;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to delete product"
      );
    }
  }
);

// Create a slice for product details
const productDetailsSlice = createSlice({
  name: "productDetails",
  initialState: {
    product: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductDetails.pending, (state) => {
        state.loading = true; // Set loading to true while fetching
        state.error = null; // Reset error state
      })
      .addCase(fetchProductDetails.fulfilled, (state, action) => {
        state.loading = false; // Set loading to false after fetching
        state.product = action.payload; // Store the product details
      })
      .addCase(fetchProductDetails.rejected, (state, action) => {
        state.loading = false; // Set loading to false on error
        state.error = action.payload; // Store error message
      })
      .addCase(deleteProduct.fulfilled, (state, action) => {
        if (state.product?.id === action.payload) {
          state.product = null; // Clear product details if deleted
        }
      })
      .addCase(deleteProduct.rejected, (state, action) => {
        state.error = action.payload; // Store error message
      });
  },
});

// Export the reducer to be used in the store
export default productDetailsSlice.reducer;
